document.addEventListener('DOMContentLoaded', function () {
    const forms = document.querySelectorAll('.sib-form');

    forms.forEach(form => {
        const emailInput = form.querySelector('input[name="EMAIL"]');
        const errorMessage = form.querySelector('.error-message');

        if (!emailInput || !errorMessage) return;

        form.addEventListener('submit', function (e) {
            e.preventDefault();

            const email = emailInput.value.trim();

            if (!isValidEmail(email)) {
                showMessage(errorMessage);
                return;
            }

            const formData = new URLSearchParams(new FormData(form));

            fetch(form.action, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: formData.toString()
            })
                .then(response => response.json())
                .then(response => {
                    if (response.success) {
                        form.reset();
                        if (response.redirect) {
                            window.location.href = response.redirect;
                        }
                    } else {
                        showMessage(errorMessage);
                    }
                })
                .catch(() => {
                    showMessage(errorMessage);
                });
        });
    });

    function isValidEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function showMessage(element) {
        element.style.display = 'block';
        setTimeout(() => {
            element.style.display = 'none';
        }, 5000);
    }
});
